var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.9,
    height: 21.035,
    viewBox: "0 0 25.9 21.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    d: "M23.238,8.623c.016.23.016.46.016.69a15,15,0,0,1-15.1,15.1A15,15,0,0,1,0,22.033a10.981,10.981,0,0,0,1.282.066,10.631,10.631,0,0,0,6.59-2.268A5.318,5.318,0,0,1,2.909,16.15a6.694,6.694,0,0,0,1,.082,5.614,5.614,0,0,0,1.4-.181,5.309,5.309,0,0,1-4.256-5.21v-.066a5.346,5.346,0,0,0,2.4.674,5.316,5.316,0,0,1-1.643-7.1A15.088,15.088,0,0,0,12.753,9.905a5.992,5.992,0,0,1-.131-1.216,5.313,5.313,0,0,1,9.187-3.632,10.451,10.451,0,0,0,3.369-1.282A5.294,5.294,0,0,1,22.843,6.7,10.641,10.641,0,0,0,25.9,5.879a11.41,11.41,0,0,1-2.662,2.744Z",
    transform: "translate(0 -3.381)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.86300a3482d5453a923feee170dbe304.svg";
export { ForwardRef as ReactComponent };